import { toCsvRecord } from '@wodi/domain';

// "Download template": a CSV file with the format's header row only, made in the browser
// from the columns the API lists, so it always matches what the import checks.

export function templateCsv(columns: readonly { key: string }[]): string {
  return `${toCsvRecord(columns.map((c) => c.key))}\r\n`;
}

export function templateHref(columns: readonly { key: string }[]): string {
  return `data:text/csv;charset=utf-8,${encodeURIComponent(templateCsv(columns))}`;
}
